import { Component, OnInit, OnDestroy, HostListener, Input } from '@angular/core';
import { Subscription } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { User } from '../models/user.model';
import { Router } from '@angular/router';
import { Title } from "@angular/platform-browser";
import { ConfigService } from '../services/config.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {

  user: User;
  userSubscription: Subscription;
  shrink: boolean;
  @Input() shrinkOffset: boolean = false;
  navbarToggled: boolean;

  isDarkTheme: boolean;
  isDarkThemeSubscription: Subscription;

  constructor(private authService: AuthService,
              private router: Router,
              private titleService: Title,
              private configService: ConfigService) {}

  setPageTitle(title: string) {
    this.titleService.setTitle(title)
  }

  ngOnInit() {
    this.userSubscription = this.authService.userSubject.subscribe(
      (user: User) => {
        this.user = user;
      }
    );
    this.authService.emitUser();

    this.isDarkThemeSubscription = this.configService.isDarkThemeSubject.subscribe(
      (isDarkTheme: boolean) => {
        this.isDarkTheme = isDarkTheme;
      }
    );
    this.configService.emitIsDarkTheme();
  }

  ngOnDestroy() {
    this.userSubscription.unsubscribe();
    this.isDarkThemeSubscription.unsubscribe();
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(e) {
    if (window.pageYOffset > 10) {
      this.shrink = true;
    } else {
      this.shrink = false;
    }
  }

  onToggleNavbar() {
    this.navbarToggled = !this.navbarToggled;
  }

  async onSignOut() {
    await this.authService.signOutUser();
  }

  onThemeChange() {
    this.configService.onSwitchTheme();
  }
}
